import { ListingsContext } from '@klokhuis/modules/Properties/context/ListingsContext';

import { SearchView } from '../../types';

export const useFilterSelectors = () => {
  const { listingsState } = ListingsContext.useContext();

  const isValidCity = () => {
    return (
      listingsState.filterResult.filters.location?.cityName &&
      listingsState.filterResult.filters.location?.cityName.toLowerCase() !==
        'india'
    );
  };

  const isMapView = () => {
    return listingsState.filterResult.filters.searchview === SearchView.Map;
  };

  const getFiltersCount = () => {
    return listingsState.filterResult.count;
  };
  const getFilters = () => {
    return listingsState.filterResult.filters;
  };
  const isSellerPage = () => {
    return !!listingsState.filterResult.filters.sellerSlug;
  };

  const getCityName = () => {
    return listingsState.filterResult.filters.location?.name || null;
  };

  const getSellerDisplayName = () => {
    return listingsState.filterResult.filters.sellerDisplayName || null;
  };

  return {
    isValidCity,
    getCityName,
    isSellerPage,
    isMapView,
    getFiltersCount,
    getFilters,
    getSellerDisplayName,
  };
};
